// extracted by mini-css-extract-plugin
module.exports = {"main":"sk-CardCover_main__mcHXh","main--fullWidth":"sk-CardCover_main--fullWidth__ChWFx"};